const ATTRIBUTES_AUTOS = {
  ATV_FUEL_TYPE: 'atvfueltype',
  ATV_MAKE: 'atvmake',
  ATV_MODEL: 'atvmodel',
  ATV_TRANSMISSION: 'atvtransmission',
  ATV_TRIM: 'atvtrim',
  ATV_TYPE: 'atvtype',
  BOATS_ENGINE_POWER: 'boatsenginepower',
  BOATS_LENGTH: 'boatslength',
  BOATS_MAKE: 'boatsmake',
  BOATS_MODEL: 'boatsmodel',
  BOATS_TRIM: 'boatstrim',
  CAB_TYPE: 'cabtype',
  CAMPERS_FUEL_TYPE: 'campersfueltype',
  CAMPERS_LENGTH: 'camperslength',
  CAMPERS_TRIM: 'camperstrim',
  CANOES_TYPE: 'canoestype',
  CAR_BODY_TYPE: 'carbodytype',
  CAR_COLOR: 'carcolor',
  CAR_ENGINE_POWER: 'chtruckenginepower',
  CAR_ENGINE: 'carenginedisplacement',
  CAR_FUEL_TYPE: 'carfueltype',
  CAR_INTERIOR_COLOR: 'carinteriorcolor',
  CAR_MAKE: 'carmake',
  CAR_MILEAGE: 'carmileageinkms',
  CAR_MODEL: 'carmodel',
  CAR_TRANSMISSION: 'cartransmission',
  CAR_TRIM: 'cartrim',
  CAR_YEAR: 'caryear',
  CARFAX: 'carprooflink',
  CONDITION: 'condition',
  CPO: 'cpoprogram',
  CYLINDERS: 'cylinders',
  DRIVETRAIN: 'drivetrain',
  ELECTRIC_RANGE: 'electricrange',
  FARMING_EQUIPMENT_FUEL_TYPE: 'farmingequipmentfueltype',
  FARMING_EQUIPMENT_TRIM: 'farmingequipmenttrim',
  FUEL_CAPACITY: 'fuelcapacity',
  GEARBOX: 'gearbox',
  HEAVY_EQUIPMENT_ENGINE_POWER: 'heavyequipenginepower',
  HEAVY_EQUIPMENT_FUEL_TYPE: 'heavyequipfueltype',
  HEAVY_EQUIPMENT_TRIM: 'heavyequiptrim',
  HEAVY_EQUIPMENT_TYPE: 'heavyequiptype',
  HORSEPOWER: 'horsepower',
  HOURS: 'hours',
  LENGTH: 'length',
  LOAD_CAPACITY: 'loadcapacity',
  MATERIAL: 'material',
  MOTORBOATS_FUEL_TYPE: 'motorboatsfueltype',
  MOTORBOATS_TYPE: 'motorboatstype',
  MOTORCYCLE_DRIVETRAIN: 'motorcyclesdrivetrain',
  MOTORCYCLE_ENGINE_POWER: 'motorcyclesenginepower',
  MOTORCYCLE_FUEL_TYPE: 'motorcyclesfueltype',
  MOTORCYCLE_MAKE: 'motorcyclesmake',
  MOTORCYCLE_MODEL: 'motorcyclesmodel',
  MOTORCYCLE_TRANSMISSION: 'motorcyclestransmission',
  MOTORCYCLE_TRIM: 'motorcyclestrim',
  MOTORHOME_ENGINE_POWER: 'motorhomesenginepower',
  MOTORHOMES_FUEL_TYPE: 'motorhomesfueltype',
  MOTORHOMES_HEIGHT: 'motorhomesheight',
  MOTORHOMES_LENGTH: 'motorhomeslength',
  MOTORHOMES_TRIM: 'motorhomestrim',
  MOTORHOMES_TYPE: 'motorhomestype',
  MOTORHOMES_WEIGHT: 'motorhomesweight',
  NUM_DOORS: 'noofdoors',
  NUM_SEATS: 'noofseats',
  PARK_MODELS_AREA: 'parkmodelsarea',
  PARK_MODELS_LENGTH: 'parkmodelslength',
  PARK_MODELS_TRIM: 'parkmodelstrim',
  PASSENGERS: 'passengers',
  PROPULSION: 'propulsion',
  PWC_FUEL_TYPE: 'pwcfueltype',
  ROOMS: 'noofrooms',
  SAILBOATS_FUEL_TYPE: 'sailboatsfueltype',
  SAILBOATS_TYPE: 'sailboatstype',
  SEATS: 'seats',
  SLEEPING_CAPACITY: 'sleepingcapacity',
  SLIDEOUTS: 'slideouts',
  SNOW_ENGINE_POWER: 'snowenginepower',
  SNOW_FUEL_TYPE: 'snowfueltype',
  SNOW_TRIM: 'snowtrim',
  SNOW_TYPE: 'snowtype',
  SPEEDS: 'speeds',
  STOCK: 'stock',
  TIME_TO_CHARGE: 'timetocharge',
  TRAILERS_TRIM: 'trailerstrim',
  TRUCK_FUEL_TYPE: 'chtruckfueltype',
  TRUCK_TRIM: 'chtrucktrim',
  VEHICLE_TYPE: 'vehicletype',
  VIN: 'vin',
  WEIGHTS_PAYLOAD_CAPACITY: 'weightspayloadcapacity',
  WHEELS: 'wheels',
  /**
   * Vehicle Features
   * Those values are a part of a group returned from the BE
   * ANVIL should extract them from the attributes array and send them separately
   */
  ADJUSTABLE_LEVERS: 'adjustablelevers',
  ADJUSTABLE_SUSPENSION: 'adjustablesuspension',
  AIR_CONDITIONING: 'airconditioning',
  ALLOY_WHEELS: 'alloywheels',
  AMENITIES: 'amenities',
  APPLIANCES: 'appliances',
  AUDIO_SYSTEM: 'audiosystem',
  BLUETOOTH: 'bluetooth',
  CARGO_RACKS: 'cargoracks',
  CRUISE_CONTROL: 'cruisecontrol',
  DUAL_CHANNEL_ABS: 'dualchannelabs',
  ELECTRONIC_REVERSE_CONTROL: 'electronicreversecontrol',
  ELECTRONIC_SUSPENSION_SYSTEM: 'electronicsuspensionsystem',
  ENTERTAINMENT_SYSTEM: 'entertainmentsystem',
  FIRE_EXTINGUISHER: 'fireextinguisher',
  GENERATOR: 'generator',
  GPS: 'gps',
  HAZARD_LIGHTS: 'hazardlights',
  HEATED_SEATS: 'electricheatedseats',
  HIGHWAY_PEGS: 'highwaypegs',
  INTERCOM: 'intercom',
  LED_LIGHTS: 'ledlights',
  LIFE_RAFT: 'liferaft',
  LIQUID_COOLING: 'liquidcooling',
  LUGGAGE_RACK: 'luggagerack',
  NAV_SYSTEM: 'navsystem',
  NAVIGATION_SYSTEM: 'navigationsystem',
  PARKING_ASSIST: 'parkingassist',
  PASSENGER_ARMRESTS: 'passengerarmrests',
  PUSH_BUTTON_START: 'pushbuttonstart',
  REAR_LIFT_PREVENTION: 'rearliftprevention',
  REVERSE_GEAR: 'reversegear',
  SATELLITE_RADIO: 'satelliteradio',
  STEREO: 'stereo',
  STORAGE: 'storage',
  SUNROOF: 'sunroof',
  TOUCH_SCREEN: 'touchscreen',
  TRAILER_HITCH: 'trailerhitch',
  TRAILER_INCLUDED: 'trailerincluded',
  WINCH: 'winch',
  WIRELESS_CHARGING: 'wirelesscharging',
} as const

const ATTRIBUTES_RE = {
  ACCESSIBLE_WASHROOMS: 'accessiblewashroomsinsuite',
  AGREEMENT_TYPE: 'agreementtype',
  AIR_CONDITIONING: 'airconditioning',
  AREA_IN_ACRES: 'areainacres',
  AREA_IN_FEET: 'areainfeet',
  AUDIO_PROMPTS: 'audioprompts',
  BALCONY: 'balcony',
  BARRIER_FREE: 'barrierfreeentrancesandramps',
  BATHROOMS: 'numberbathrooms',
  BEDROOMS: 'numberbedrooms',
  BICYCLE_PARKING: 'bicycleparking',
  BRAILLE_LABELS: 'braillelabels',
  CABLE_TV: 'cabletv',
  CONCIERGE: 'concierge',
  DATE_AVAILABLE: 'dateavailable',
  DISHWASHER: 'dishwasher',
  ELEVATOR: 'elevator',
  FOR_RENT_BY_HOUSING: 'forrentbyhousing',
  FOR_SALE_BY_HOUSING: 'forsalebyhousing',
  FRIDGE: 'fridgefreezer',
  FURNISHED: 'furnished',
  GYM: 'gym',
  HEAT: 'heat',
  HYDRO: 'hydro',
  INTERNET: 'internet',
  LAUNDRY_BUILDING: 'laundryinbuilding',
  LAUNDRY_UNIT: 'laundryinunit',
  PARKING: 'numberparkingspots',
  PET_FRIENDLY: 'petsallowed',
  POOL: 'pool',
  RENTALS_VIRTUAL_OPTIONS: 'rentalsvirtualoptions',
  SMOKING_PERMITTED: 'smokingpermitted',
  STORAGE_LOCKER: 'storagelocker',
  TERM_AGREEMENT: 'termagreement',
  TRAILERS_HITCH: 'trailerhitch',
  TWENTY_FOUR_HOUR_SECURITY: 'twentyfourhoursecurity',
  UNIT_TYPE: 'unittype',
  VISUAL_AIDS: 'visualaids',
  WATER: 'water',
  WHEELCHAIR_ACCESSIBLE: 'wheelchairaccessible',
  YARD: 'yard',
} as const

const ATTRIBUTES_PETS = {
  BIRTHDAY: 'birthdate',
  BIRTH_DATE: 'birthdate',
  BREED: 'breed',
  FOR_SALE_BY_PETS: 'petofferedby',
  GENDER: 'sex',
  REHOME_DATE: 'rehomedate', // appended on FE, not returned from BE
} as const

const ATTRIBUTES_BUY_SELL = {
  BRAND_DESKTOP: 'desktopbrand',
  BRAND_LAPTOP: 'laptopbrand',
  BRAND_PHONE: 'phonebrand',
  BRAND_TABLET: 'tabletbrand',
  CASHLESS_PAYMENT: 'cashless',
  CASH_ACCEPTED: 'cashaccepted',
  CURBSIDE: 'curbside',
  DROP_OFF: 'dropoff',
  FRAME_SIZE: 'framesize',
  JEWELLERY_TYPE: 'jewellerytype',
  PHONE_CARRIER: 'phonecarrier',
  SCREEN_SIZE_LAPTOP: 'laptopscreensize',
  SHIPPING: 'shipping',
  SIZE: 'size',
}

const ATTRIBUTES_JOBS = {
  COMPANY: 'company',
  JOB_TYPE: 'jobtype',
  JOB_OFFERED_BY: 'jobofferedby',
  APPLICATION_LINK: 'applicationlink',
}

const ATTRIBUTES_VACATION_RENTALS = {
  AVAILABILITY_END_DATE: 'availabilityenddate',
  AVAILABILITY_START_DATE: 'availabilitystartdate',
  CITY: 'city',
  MIN_NIGHTS: 'minnights',
  SLEEPS: 'maxpeople',
  VACATION_TYPE: 'vacationtype',
}

const ATTRIBUTES_COMMUNITY = {
  AGE: 'age',
  SPORT: 'sport',
}

const ATTRIBUTES_EVENTS = {
  END_DATE: 'enddate',
  END_TIME: 'endtime',
  EVENT_TYPE: 'eventtype',
  START_DATE: 'startdate',
  START_TIME: 'starttime',
}

const ATTRIBUTES_COMMON = {
  FOR_SALE_BY: 'forsaleby',
  FULFILLMENT: 'fulfillment',
  PAYMENT: 'payment',
  /**
   * Dealer Updates
   * Those values are a part of a group returned from the BE
   * ANVIL should extract them from the attributes array and send them separately
   */
  BY_APPOINTMENT_ONLY: 'byappointmentonly',
  HOME_DELIVERY: 'homedelivery',
  ONLINE_APPLICATION: 'onlineapp',
  ONLINE_FINANCING: 'onlinefinancing',
  ONLINE_PURCHASING: 'onlinepurchasing',
  PAYMENT_DEFERRALS: 'paymentdeferrals',
  RETURN_POLICY: 'returnpolicy',
  SERVICE_DROPOFF: 'servicedropoff',
  SERVICE_OPEN: 'serviceopen',
  SHOWROOM_CLOSED: 'showroomclosed',
  SHOWROOM_OPEN: 'showroomopen',
  VIDEO_CHAT: 'videochat',
  VIRTUAL_APPRAISAL: 'virtualappraisal',
  VIRTUAL_TOUR: 'virtualtour',
}

export const ATTRIBUTES = {
  ...ATTRIBUTES_COMMON,
  ...ATTRIBUTES_AUTOS,
  ...ATTRIBUTES_BUY_SELL,
  ...ATTRIBUTES_COMMUNITY,
  ...ATTRIBUTES_EVENTS,
  ...ATTRIBUTES_JOBS,
  ...ATTRIBUTES_PETS,
  ...ATTRIBUTES_RE,
  ...ATTRIBUTES_VACATION_RENTALS,
} as const

/**
 * This is a list of all attributes that should be rendered as a link
 */
export const ATTRIBUTES_URL_VALUE = [ATTRIBUTES.APPLICATION_LINK]

/** ATTRIBUTES VALUES */
export enum VEHICLE_TYPE_VALUES {
  NEW = 'new',
  USED = 'used',
  LEASE = 'lease',
  DAMAGED = 'damaged',
  SALVAGE = 'salvage',
}

export enum UNIT_TYPE_VALUES {
  APARTMENT = 'apartment',
  BASEMENT_APARTMENT = 'basement-apartment',
  CONDO = 'condo',
  DUPLEX = 'duplex-triplex',
  HOUSE = 'house',
  TOWNHOUSE = 'townhouse',
}

export enum FOR_SALE_BY_VALUES {
  DEALER = 'delr',
  OWNER = 'ownr',
}

export enum FOR_SALE_BY_PETS_VALUES {
  REGISTERED_BREEDER = 'regbreeder',
  OWNER = 'owner',
}

export enum JOB_OFFERED_BY_VALUES {
  PROFESSIONAL = 'jobs_professional',
  INDIVIDUAL = 'individual',
}

export enum PET_FRIENDLY_VALUES {
  LIMITED = 'limited',
  FALSE = '0',
  TRUE = '1',
}

export enum PET_GENDER_VALUES {
  FEMALE = 'female',
  MALE = 'male',
  NOT_SPECIFIED = 'notspecified',
}

export enum BOOLEAN_NUMERIC_VALUES {
  YES = '1',
  NO = '0',
}

export enum BOOLEAN_TEXT_VALUES {
  YES = 'true',
  NO = 'false',
}

export enum TRANSMISSION_VALUES {
  MANUAL = '1',
  AUTOMATIC = '2',
  OTHER = '3',
  SEMI_AUTOMATIC = '0',
}

export enum HEAVY_TRUCK_TRANSMISSION_VALUES {
  MANUAL_GEAR = 'manual-gear',
  AUTOMATIC_GEAR = 'automatic-gear',
  AMT = 'amt',
  OTHER = 'other',
}

export enum CAR_DRIVETRAIN_VALUES {
  '4X4' = '4x4',
  AWD = 'awd',
  FWD = 'fwd',
  OTHER = 'other',
  RWD = 'rwd',
}

export enum FUEL_VALUES {
  DIESEL = 'diesel',
  ELECTRIC = 'electric',
  GAS = 'gas',
  HYBRID = 'hybrid',
  OTHER = 'other',
}

export enum CAR_MAKE_VALUES {
  ACURA = 'acura',
  ALPHAROMEO = 'alpharomeo',
  AM_GENERAL = 'am_general',
  AMC = 'amc',
  ASTON_MARTIN = 'astnmrtn',
  AUDI = 'audi',
  BENTLEY = 'bentley',
  BMW = 'bmw',
  BRICKLIN = 'bricklin',
  BUGATTI = 'bugatti',
  BUICK = 'buick',
  CADILLAC = 'cadillac',
  CHEVROLET = 'chevrolet',
  CHRYSLER = 'chrysler',
  DAEWOO = 'daewoo',
  DATSUN = 'datsun',
  DAIHATSU = 'diahatsu',
  DODGE = 'dodge',
  EAGLE = 'eagle',
  FERRARI = 'ferrari',
  FIAT = 'fiat',
  FORD = 'ford',
  GEO = 'geo',
  GMC = 'gmc',
  HONDA = 'honda',
  HUMMER = 'hummer',
  HYUNDAI = 'hyundai',
  INFINITI = 'infiniti',
  INTERNATIONAL_HARVESTER = 'inthrvstr',
  ISUZU = 'isuzu',
  JAGUAR = 'jaguar',
  JEEP = 'jeep',
  KIA = 'kia',
  LAND_ROVER = 'landrover',
  LEXUS = 'lexus',
  LINCOLN = 'lincoln',
  LAMBORGHINI = 'lmbrghn',
  LOTUS = 'lotus',
  MASERATI = 'maserati',
  MAYBACH = 'maybach',
  MAZDA = 'mazda',
  MERCEDES = 'mercedes',
  MERCURY = 'mercury',
  MG = 'mg',
  MINI = 'mini',
  MITSUBISHI = 'mitsubishi',
  NISSAN = 'nissan',
  OLDSMOBILE = 'oldsmobile',
  OPEL = 'opel',
  PEUGEOT = 'peugeot',
  PLYMOUTH = 'plymouth',
  PONTIAC = 'pontiac',
  PORSCHE = 'porsche',
  RAM = 'ram',
  RENAULT = 'renault',
  ROLLS_ROYCE = 'rollsroyce',
  SAAB = 'saab',
  SATURN = 'saturn',
  SCION = 'scion',
  SHELBY = 'shelby',
  SMART = 'smart',
  SUBARU = 'subaru',
  SUZUKI = 'suzuki',
  TOYOTA = 'toyota',
  TRIUMPH = 'triumph',
  VOLKSWAGEN = 'volkwagen',
  VOLVO = 'volvo',
  OTHER_MAKE = 'othrmake',
  AUSTIN_HEALEY = 'austinhealey',
  MERCEDES_AMG = 'mercedes-amg',
  TESLA = 'tesla',
  GENESIS = 'genesis',
  MCLAREN = 'mclaren',
  POLESTAR = 'polestar',
}

export enum CAR_BODY_TYPE_VALUES {
  CONVERTIBLE = 'conv',
  COUPE = 'coup',
  HATCHBACK = 'htchbck',
  PICKUP_TRUCK = 'pickuptruck',
  SEDAN = 'sedan',
  SUV_CROSSOVER = 'suvcrossover',
  VAN = 'vanminicomma',
  WAGON = 'wagon',
  OTHER = 'othrbdytyp',
}

export enum ATTRIBUTE_FILTER_COLORS {
  BLACK = 'black',
  GREY = 'gray',
  SILVER = 'silver',
  WHITE = 'white',
  BEIGE = 'beige',
  GOLD = 'gold',
  BROWN = 'brown',
  BURGUNDY = 'burgundy',
  RED = 'red',
  BLUE = 'blue',
  GREEN = 'green',
  TEAL = 'teal',
  YELLOW = 'yellow',
  ORANGE = 'orange',
  PURPLE = 'purple',
  PINK = 'pink',
  OTHER = 'other',
  OFFWHITE = 'off_white',
  TAN = 'tan',
}

export enum FULFILLMENT_VALUES {
  DELIVERY = 'delivery',
  SHIPPING = 'shipping',
  CURBSIDE = 'curbside',
}

export enum PAYMENT_VALUES {
  CASHLESS = 'cashless',
  CASH_ACCEPTED = 'cashaccepted',
}

export enum RENTALS_VIRTUAL_OPTIONS_VALUES {
  ONLINE_APPLICATION = 'onlineapplication',
  VIDEO_CHAT = 'videochat',
  VIDEO_TOUR = 'virtualtour',
}

export enum TERM_AGREEMENT_VALUES {
  RENT_DEFERRAL = 'rentdeferral',
}

export enum FOR_RENT_BY_HOUSING_VALUES {
  OWNER = 'ownr',
  PROFESSIONAL = 'reprofessional',
}

export enum SMOKING_PERMITTED_VALUES {
  NO = '0',
  YES = '1',
  OUTDOOR_ONLY = '2',
}

type AttributeFilterColorConfig = {
  color: string | string[]
  borderColor?: string
}

export type AttributeFilterColorMap = {
  [key in ATTRIBUTE_FILTER_COLORS]: AttributeFilterColorConfig
}

export const AttributeColorVisualMap: AttributeFilterColorMap = {
  [ATTRIBUTE_FILTER_COLORS.BLACK]: { color: '#343746' },
  [ATTRIBUTE_FILTER_COLORS.GREY]: { color: '#8E909B' },
  [ATTRIBUTE_FILTER_COLORS.SILVER]: { color: ['#ECECEE', '#DBDBDB'], borderColor: '#E1E1E2' },
  [ATTRIBUTE_FILTER_COLORS.WHITE]: { color: '#FFFFFF', borderColor: '#ECECEE' },
  [ATTRIBUTE_FILTER_COLORS.BEIGE]: { color: '#EFE8D7' },
  [ATTRIBUTE_FILTER_COLORS.GOLD]: { color: ['#CDC184', '#A09B11'], borderColor: '#CDC184' },
  [ATTRIBUTE_FILTER_COLORS.BROWN]: { color: '#7E6043' },
  [ATTRIBUTE_FILTER_COLORS.BURGUNDY]: { color: '#731A1A' },
  [ATTRIBUTE_FILTER_COLORS.RED]: { color: '#BB3C4D' },
  [ATTRIBUTE_FILTER_COLORS.BLUE]: { color: '#155E9B' },
  [ATTRIBUTE_FILTER_COLORS.GREEN]: { color: '#199143' },
  [ATTRIBUTE_FILTER_COLORS.TEAL]: { color: '#367B7F' },
  [ATTRIBUTE_FILTER_COLORS.YELLOW]: { color: '#FFD706' },
  [ATTRIBUTE_FILTER_COLORS.ORANGE]: { color: '#F8AA17' },
  [ATTRIBUTE_FILTER_COLORS.PURPLE]: { color: '#762986' },
  [ATTRIBUTE_FILTER_COLORS.PINK]: { color: '#F4A5DE' },
  [ATTRIBUTE_FILTER_COLORS.OTHER]: {
    color: ['#9B44AD', '#37A4D2', '#3CB587', '#37A864', '#B5B03C', '#AC5050'],
    borderColor: '#BEC4C0',
  },
  [ATTRIBUTE_FILTER_COLORS.OFFWHITE]: { color: '#F7EFDF' },
  [ATTRIBUTE_FILTER_COLORS.TAN]: { color: '#F8AA1757' },
}
